import { render, staticRenderFns } from "./TableGlobalMedien.vue?vue&type=template&id=b0233286&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./TableGlobalMedien.vue?vue&type=script&lang=js"
export * from "./TableGlobalMedien.vue?vue&type=script&lang=js"
import style0 from "./TableGlobalMedien.vue?vue&type=style&index=0&id=b0233286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0233286",
  null
  
)

export default component.exports